import React from 'react';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ViewColumnOutlinedIcon from '@mui/icons-material/ViewColumnOutlined';
import {AVAILABLE_PRODUCT_COLUMNS} from '../../constants/tableColumns';

/**
 * Field selector for the products table.
 * Renders a "Columns" button that opens a checkbox menu of available columns.
 * Locked columns (e.g. product title) are shown checked and disabled.
 *
 * Props:
 *   visibleFields - string[] of currently-visible column field keys
 *   onToggleField(field) - toggle a column's visibility
 */
const ColumnPicker = ({visibleFields, onToggleField}) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    return (
        <>
            <Button
                size="small"
                variant="outlined"
                startIcon={<ViewColumnOutlinedIcon fontSize="small" />}
                onClick={(e) => setAnchorEl(e.currentTarget)}
            >
                Columns
            </Button>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                transformOrigin={{vertical: 'top', horizontal: 'right'}}
            >
                {AVAILABLE_PRODUCT_COLUMNS.map((col) => {
                    const checked = visibleFields.includes(col.field);
                    return (
                        <MenuItem
                            key={col.field}
                            dense
                            disabled={col.locked}
                            onClick={() => onToggleField(col.field)}
                        >
                            <ListItemIcon sx={{minWidth: 0, mr: 1}}>
                                <Checkbox
                                    edge="start"
                                    size="small"
                                    checked={checked || Boolean(col.locked)}
                                    tabIndex={-1}
                                    disableRipple
                                    sx={{p: 0}}
                                />
                            </ListItemIcon>
                            <ListItemText primary={col.headerName} />
                        </MenuItem>
                    );
                })}
            </Menu>
        </>
    );
};

export default ColumnPicker;
